import SpecialtiesHero from '../../Specialties/SpecialtiesHero/SpecialtiesHero'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { useAppContext } from '../../../context/AppState/AppContext';

export default function VisionSection() {
  const {jsonTexts, jsonMedia} = useAppContext();
  const {description, title} = jsonTexts.aboutUs.visionSection;

  const image = jsonMedia?.institutional?.visionBannerImage
  const {width} = useWindowDimensions()
  const isMobile = width <= 768
  return (
      < SpecialtiesHero firstImage  height={isMobile ? 200 : 250} title={title} imageUrl={image} description={description} square right='0' />
  )
}
